import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
const AuthCtx = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null), [tenant, setTenant] = useState(null);
  useEffect(() => {
    (async () => { try { const { data } = await api.get("/auth/me"); setUser(data.user); setTenant(data.tenant); }
      catch { setUser(false); setTenant(null); } })();
  }, []);
  const login = async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); setUser(data.user); setTenant(data.tenant); return data; };
  const register = async payload => { const { data } = await api.post("/auth/register", payload); setUser(data.user); setTenant(data.tenant); return data; };
  const logout = async () => {
    try {
      const { data } = await api.post("/auth/logout");
      if (data?.ok !== true) throw new Error("Logout non confermato");
      setUser(false); setTenant(null);
      if (data.wordpress_revoked === false) toast.warning("Sessione QuoteOS chiusa. Revoca sul portale non confermata: esci anche da SOFMAT.");
      return true;
    } catch (error) {
      toast.error("Uscita non completata. La sessione non viene dichiarata chiusa: riprova.");
      // Propagation prevents the calling layout from falsely redirecting as logged out.
      throw error;
    }
  };
  const refresh = async () => { const { data } = await api.get("/auth/me"); setUser(data.user); setTenant(data.tenant); };
  return <AuthCtx.Provider value={{ user, tenant, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}
export const useAuth = () => useContext(AuthCtx);
